import React, { useContext } from 'react';
import { RicosDirectionContext, RicosNodeContextProvider } from 'ricos-context';
import { s as styles } from '../../../../lists-16976e92.js';
import { r as rtlStyles } from '../../../../rtl.rtlignore-09de95fb.js';
import classnames from 'classnames';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BulletedList = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { textDirection } = useContext(RicosDirectionContext);
  const bulletedListClassName = classnames(
    styles.bulletedlist,
    rtlStyles[textDirection || "ltr"]
  );
  return /* @__PURE__ */ React.createElement("ul", { className: bulletedListClassName }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes })));
};
const BulletedListRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(BulletedList, __spreadValues({ key: node.id, node }, props));
};

export { BulletedListRenderer as default };
//# sourceMappingURL=bulletedList.js.map
